import { render } from "./RecursiveCategories.vue?vue&type=template&id=49167049&scoped=true"
import script from "./RecursiveCategories.vue?vue&type=script&lang=js"
export * from "./RecursiveCategories.vue?vue&type=script&lang=js"

import "./RecursiveCategories.vue?vue&type=style&index=0&id=49167049&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49167049"]])

export default __exports__